import {
  AppBar,
  Box,
  Container,
  Divider,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo-white.png";
import useAuth from '../useAuth';
import Logout from "@mui/icons-material/Logout";
import AccountCircle from "@mui/icons-material/AccountCircle";
import ManageAccounts from "@mui/icons-material/ManageAccounts";
import ExchangeRateWidget from "./ExchangeRateWidget";

export const NavBar: React.FC<{}> = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('isLoggedIn');
  const { logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const userData = (() => {
    try { return JSON.parse(localStorage.getItem("user") || "{}"); }
    catch { return {}; }
  })();

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="sticky">
        <Container maxWidth="xl">
          <Toolbar>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography>
                  <img
                    src={logo}
                    alt="Logo"
                    style={{
                      width: "100px",
                      height: "auto",
                      marginLeft: "20px",
                      marginBottom: "-5px",
                      cursor: "pointer"
                    }}
                    onClick={(isLoggedIn) ? () => navigate("/") : () => navigate("login")}
                  />
                </Typography>
              </Grid>
              <Grid item>
                <Stack direction="row" spacing={2} alignItems="center">
                  {isLoggedIn && (
                    <>
                      <ExchangeRateWidget />
                      <IconButton onClick={handleMenuOpen} sx={{ color: '#fff' }}>
                        <AccountCircle />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                      >
                        <MenuItem disabled sx={{ opacity: '1 !important' }}>
                          <ListItemText
                            primary={userData.nombre || "Usuario"}
                            secondary={userData.rol || ""}
                          />
                        </MenuItem>
                        {userData.rol === "Superadministrador" && (
                          <>
                            <Divider />
                            <MenuItem onClick={() => { handleMenuClose(); navigate("/usuarios"); }}>
                              <ListItemIcon><ManageAccounts fontSize="small" /></ListItemIcon>
                              Gestión de Usuarios
                            </MenuItem>
                          </>
                        )}
                        <Divider />
                        <MenuItem onClick={() => { handleMenuClose(); logout(); }}>
                          <ListItemIcon><Logout fontSize="small" /></ListItemIcon>
                          Cerrar Sesión
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </Stack>
              </Grid>
            </Grid>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
};
